<template>
  <div class="box-bolao-info">

    <div v-if="!cardsLoading && cards.length">
      <div class="box_wheel_bolao">
        <div class="wheel_bolao_detail">
          <div
            class="expand-game"
            :class="{
              'expand-game--on': lotteriesWithExpand.includes(lottery?.id),
              'expand-game--active': expanded,
            }"
          >
            <div class="expand-game__wrap">
              <div class="readonly-game">
                <div
                  class="grid-tens-bolao-wheel"
                  v-if="!cardsLoading && cards.length"
                >
                <slider-game-tens @slider-number="getNumberSlider">
                  <div
                      v-for="card in cards"
                      :key="`card-option-${card.betNumberFormatted}`"
                    >
                      <div v-if="lottery?.slug === 'loteria-federal'">
                        <p>
                          Para apostar na Loteria Federal basta escolher um
                          bilhete (ele possui um número de série) e quantas
                          cotas quer comprar do mesmo
                          <strong>(são 10 no total)</strong>. Quanto mais cotas
                          comprar, maior pode ser o seu prêmio.
                        </p>
                        <p>
                          Em cada sorteio, cinco números de série são premiados
                          e o prêmio equivalente a cada um deles é dividido
                          entre as cotas do bilhete. Ou seja: a premiação
                          responde ao inteiro
                          <strong>(bilhete completo)</strong> e cada ganhador
                          receberá o correspondente a quantas cotas possui.
                        </p>
                        <div class="text-center">
                          <p class="mt-4">O número de série deste bilhete é:</p>
                          <div class="box_game_bolao_federal">
                            <p>{{ cards[0].bet }}</p>
                          </div>
                        </div>
                      </div>
                      <gamesupersete
                        v-if="lottery?.gameType === 'supersete'"
                        :lottery="lottery"
                        :card="card"
                        :readOnly="true"
                      ></gamesupersete>
                      <gametens
                        v-if="lottery?.gameType === 'tens'"
                        :lottery="lottery"
                        :card="card"
                        :readOnly="true"
                      >
                      </gametens>
                      <gameloteca
                        v-if="lottery?.gameType === 'loteca'"
                        :lottery="lottery"
                        :card="card"
                        :matchlist="game?.drawInfo.footballScheme.matchList"
                        :oneColumn="true"
                        :readOnly="true"
                      ></gameloteca>
                    </div>
                </slider-game-tens>
                </div>
              </div>
            </div>
            <button class="expand-game__button" @click="expanded = !expanded">
              {{ expanded ? "Fechar" : "Expandir" }} volante
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        class="box_all_cards_bolao"
        v-if="!cardsLoading && lottery?.slug !== 'loteria-federal'"
      >
        <div class="w-100">
          <span class="w-600">Número do cartão:</span>
           {{(sliderNumber)?.toString().padStart(5, '0')}} de {{(allItemsCards).toString().padStart(5, '0')}}
        </div>
        <button class="btn btn-lot btn-outline w-100" @click="allCardsBolao()">
          Ver todos os cartões
        </button>
      </div>
    </div>
    <div v-if="cardsLoading">
      <box-game-tens-skeleton></box-game-tens-skeleton>
    </div>
    <div class="box-bolao-info__info" v-if="gameLoaded">
      <div class="box-bolao-info__info__top d-flex justify-content-between">
        <div class="box-bolao-info__info__title">
          <strong>{{
            game.drawInfo.estimatedPrize > 0
              ? "R$ " + game.drawInfo.estimatedPrizeText
              : products.drawInfo.estimatedPrizeText
          }}</strong>
          <div class="box-bolao-info__info__draw-number d-none d-lg-block">
            Concurso {{ game.drawInfo.drawNumber }}
          </div>
        </div>
        <div class="label-time">
          <time class="bolao-page__header__draw-date">{{
            game.drawInfo.drawDateText
          }}</time>
        </div>
      </div>

      <div class="box-bolao-info__info__body">
        <div
          class="box-bolao-info__info__draw-summary d-flex justify-content-between align-items-center mb-3"
        >
          <div class="box-bolao-info__info__chances">
            <div
              class="box-bolao-info__info__chances__icon-lottery"
              v-if="lottery"
            >
              <img
                :src="`/media/boloes/lottery-icons/${lottery.slug}.svg`"
                alt=""
              />
            </div>
            <div class="box-bolao-info__info__chances__text">
              <div
                class="box-bolao-info__info__chances__text__draw-number d-lg-none"
              >
                Concurso {{ game.drawInfo.drawNumber }}
              </div>
              <div class="box-bolao-info__info__chances__text__draw">
                {{ game.name }}
              </div>
              <div
                class="box-bolao-info__info__chances__text__line d-none d-lg-flex"
                v-if="game.moreChances"
              >
                <div class="box-bolao-info__info__chances__text__number">
                  {{ game.moreChances }}x
                </div>
                <div class="box-bolao-info__info__chances__text__description">
                  + chances de ganhar
                </div>
              </div>
            </div>
          </div>

          <div class="box-bolao-info__info__bolao-price lot-color">
            <div class="box-bolao-info__info__bolao-price__label">
              Preço por cota:
            </div>
            {{ game.unitPriceText }}
          </div>
        </div>

        <div
          class="box-bolao-info__info__chances__text__line d-lg-none"
          v-if="game.moreChances"
        >
          <div class="box-bolao-info__info__chances__text__number">
            {{ game.moreChances }}x
          </div>
          <div class="box-bolao-info__info__chances__text__description">
            + chances de ganhar
          </div>
        </div>

        <div
          class="box-bolao-info__info__config-line d-flex justify-content-between"
        >
          <div
            class="box-bolao-info__info__game-options"
            v-if="game.items.length"
          >
            <div class="box-bolao-info__info__game-options__label">
              Opção de jogo
            </div>
            <ul class="box-bolao-info__info__game-options__list">
              <li
                class="box-bolao-info__info__game-options__list__item"
                v-for="(item, index) in game.items"
                :key="`game-option-${item.serie}`"
              >
                <button
                  class="box-bolao-info__info__game-options__list__item__button"
                  :class="{ active: currentGameOptionIndex === index }"
                  @click="currentGameOptionIndex = index"
                >
                  {{ item.serie }}
                </button>
              </li>
            </ul>
          </div>

          <div class="box-bolao-info__info__quotes">
            <div class="box-bolao-info__info__quotes__available d-flex justify-content-between">

              <div class="box-bolao-info__info__quotes__available">
                Cotas disponíveis {{ currentGameOption.unitsInStock }}
                <strong>/{{ currentGameOption.units }}</strong>
              </div>

           <span>
            <strong>{{intToReal(currentGameOption.myUnits * game.unitPrice) }}</strong>
           </span>
            </div>
            <div class="box-bolao-info__info__quotes__select">
              <button
              :disabled="currentGameOption.myUnits === 1"
                class="box-bolao-info__info__quotes__select__btn"
                v-on:click="setUnits(currentGameOptionIndex, '-')"
              >
                -
              </button>
              <input
                type="tel"
                value="1"
                maxlength="4"
                v-model="currentGameOption.myUnits"
                v-on:keyup.enter="
                  setUnits(
                    currentGameOptionIndex,
                    currentGameOption.myUnits,
                    true
                  )
                "
                v-on:blur="
                  setUnits(currentGameOptionIndex, currentGameOption.myUnits)
                "
              />
              <button
                :disabled="currentGameOption.myUnits === currentGameOption.units ||
                currentGameOption.myUnits === currentGameOption.unitsInStock"
                class="box-bolao-info__info__quotes__select__btn"
                v-on:click="setUnits(currentGameOptionIndex, '+')"
              >
                +
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="box-bolao-info__info__footer">
        <button
          :disabled="currentGameOption.myUnits === 0"
          v-on:click="setUnits(currentGameOptionIndex, 'addCart', true)"
          class="btn btn-primary btn-block"
        >
          <span v-text="itemCart ? 'Atualizar itens':'Adicionar ao carrinho'"></span>
        </button>
      </div>
    </div>
  </div>
</template>
<style src="./BoxBolaoInfo.scss" scoped></style>
<script>
import getCards from '@services/inventory/getCards';
import BoxGameTensSkeleton from './BoxGameTensSkeleton.vue';
import intToReal from '@helpers/intToReal';
import SliderGameTens from './SliderGameTens.vue'

export default {
  emits: ['setunits'],
  components: {
    gameloteca: () => import('../../CustomGame/_CustomGameLoteca.vue'),
    gametens: () => import('../../CustomGame/_CustomGameTens.vue'),
    gamesupersete: () => import('../../CustomGame/_CustomGameSuperSete.vue'),
    'box-game-tens-skeleton': BoxGameTensSkeleton,
    'slider-game-tens': SliderGameTens
  },
  props: {
    lottery: null,
    game: null,
    insidecart: null,
    updatecart: null
  },
  data: function () {
    return {
      itemCart: false,
      sliderNumber: 1,
      cart: 0,
      buttonSlider: null,
      allItemsCards: null,
      lotteriesWithExpand: [3, 6, 9, 11, 12],
      expanded: false,
      cardsLoading: false,
      currentGameOptionIndex: 0,
      readonlygame: true,
      cards: [],
      tinySliderOptions: {
        items: 1,
        mode: 'gallery',
        center: false,
        autoplay: false,
        edgePadding: 0,
        autoplayButtonOutput: true,
        gutter: 20,
        loop: false,
        nav: true,
        controlsText: ['', '']
      }
    };
  },
  methods: {
    intToReal: intToReal,
    getCards () {
      this.cardsLoading = true;
      const params = {
        productID: this.currentGameOption.id,
        categoryID: 1,
        pageSize: 3,
        lotteryID: this.game.drawInfo.lotteryID,
        isOrdered: false
      };

      getCards(params)
        .then((res) => {
          if (this.lottery?.gameType === 'tens') {
            res.cards.forEach((card) => {
              card.bet = card.betFormatted.map((ten) => +ten);
            });
          }

          if (this.lottery?.hasKey && this.lottery?.slug !== 'mais-milionaria') {
            res.cards.forEach((card) => {
              card.key = this.lottery.keyValues.find(
                (key) => key.name === card.key
              ).number;
            });
          }
          if (this.lottery?.slug === 'mais-milionaria') {
            res.cards.forEach((card) => {
              card.listKeys = card.keyFormatted.map((clover) => +clover);
            });
          }
          if (this.lottery?.gameType === 'supersete') {
            res.cards.forEach((card) => {
              card.bet = [card.betFormatted];
            });
          }

          if (this.lottery?.gameType === 'loteca') {
            res.cards.forEach((card) => {
              card.bet = [card.betFormatted];
            });
          }
          this.cards = res.cards;
          this.allItemsCards = res.pagination.TotalCount;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.cardsLoading = false;
        });
    },
    cardChange (ev) {
      console.info(ev);
    },
    setUnits (itemIndex, newUnits, isImmediately = false) {
      this.$emit('setunits', {
        itemIndex,
        newUnits,
        isImmediately
      });
    },
    allCardsBolao () {
      Modal.open('JOGO', {
        productID: this.currentGameOption.id,
        drawNumber: this.game.drawInfo.drawNumber
      });
    },
    getNumberSlider (value) {
      this.sliderNumber = value;
    },
    btnChange () {
      this.insidecart.items.forEach(() => {
        const ItemsInsideCart = this.insidecart.items.map((item) =>
          item.productID
        )
        if (ItemsInsideCart.includes(this.game.items[this.currentGameOptionIndex].id)) {
          this.itemCart = true
        }
      })
    }
  },
  watch: {
    currentGameOptionIndex () {
      this.getCards();
    },
    gameLoaded (newVal, oldVal) {
      if (!oldVal && newVal) {
        this.getCards();
      }
    },
    cardsLoading (val) {
      if (val === true) {
        this.sliderNumber = 1
        if (this.updatecart?.includes(this.game.items[this.currentGameOptionIndex].id)) {
          this.itemCart = true
        }
        if (!this.updatecart?.includes(this.game.items[this.currentGameOptionIndex].id)) {
          this.itemCart = false
        }
        this.btnChange();
      }
    },
    updatecart (val) {
      if (!val.length) {
        this.itemCart = false
      }
      if (val?.includes(this.game.items[this.currentGameOptionIndex].id)) {
        this.itemCart = true
      }
      if (!val?.includes(this.game.items[this.currentGameOptionIndex].id)) {
        this.itemCart = false
      }
    }
  },
  computed: {
    gameLoaded () {
      return !!this.game && !!this.lottery;
    },
    currentGameOption () {
      return this.game.items[this.currentGameOptionIndex];
    }
  },
  created () {
    this.getCards();
    this.btnChange();
    this.game.items.sort((a, b) => a.serie - b.serie)
  }
};
</script>
